module.exports = __webpack_public_path__ + "img/Normanton-Park-Drone-View.12471423.gif";